export default "__VITE_ASSET__nmcgspIC__"